module.exports = __webpack_public_path__ + "img/GH-kyujin-top-illustration001.55cd9636.webp";